export default "__VITE_ASSET__YpFKB$3K__"